export default __webpack_public_path__ + "static/media/icon_mobile_cash_dollar.cfb8291c.svg";